import * as React from "react";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import useProductName from "brand-customization/useProductName";
import { DATA_LAKE_BACKEND_CONFIG_QUERY_KEYS } from "data-lake/Constants";
import useDataLakeConfigMutation from "data-lake/configurations/hooks/useDataLakeConfigMutation";
import { ConfirmDialog, IfPermitted } from "components/common";
import { Alert, Button } from "components/bootstrap";
const DataLakeBackendActivateButton = ({ backend, isActiveBackend, config }) => {
  const productName = useProductName();
  const [showModal, setShowModal] = useState(false);
  const { onUpdateDataLakeConfig } = useDataLakeConfigMutation();
  const queryClient = useQueryClient();
  const onModalClose = () => {
    setShowModal(false);
  };
  const onButtonClick = () => {
    setShowModal(true);
  };
  const onConfirm = () => {
    onUpdateDataLakeConfig({ config: { ...config, active_backend: backend.id } }).then(() => {
      queryClient.invalidateQueries({ queryKey: DATA_LAKE_BACKEND_CONFIG_QUERY_KEYS });
      onModalClose();
    });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showModal && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showModal,
      onConfirm,
      onCancel: onModalClose,
      title: "Activate Data Lake backends ?"
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, "You are about to activate ", /* @__PURE__ */ React.createElement("strong", null, backend.title), " Data Lake backend.", !isActiveBackend && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, /* @__PURE__ */ React.createElement("p", null, " You are about to switch currently enabled backend."), /* @__PURE__ */ React.createElement("p", null, "Data already saved to this backend will not be moved to the newly enabled backend."), /* @__PURE__ */ React.createElement("p", null, "Only data from the currently active backend is accessible from ", productName, ".")), /* @__PURE__ */ React.createElement("p", null, "Are you sure you want to continue?"))
  ), !isActiveBackend && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "data_lake_backend_config:update" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "default", bsSize: "medium", onClick: onButtonClick }, "Activate")));
};
export default DataLakeBackendActivateButton;
